import { connect } from 'react-redux';

import ProfileVisitorsRoot from 'javascripts/user_cards/profile_visitor_cards';
import { fetchProfileVisitorCards } from 'javascripts/redux_store/profile_visitor_cards/actions';

const mapState = ({ ProfileVisitorCards }) => ({
  cards: ProfileVisitorCards.models,
  meta: ProfileVisitorCards.meta,
});

const mapDispatch = { fetchProfileVisitorCards };

export const ProfileVisitorsContainer = connect(
  mapState,
  mapDispatch,
)(ProfileVisitorsRoot);
